import { styled } from '@mui/material/styles';
import React from 'react';
import colors from 'src/utils/colors';

const AuthTextButtonInner = styled('p')({
  color: colors.darkBlue,
  fontSize: '18px',
  fontWeight: 500,
  border: 'none',
  textDecoration: 'underline',
  marginTop: '16px',
  textAlign: 'center',
  cursor: 'pointer',
  fontFamily: 'Geist'
});

const AuthTextButton: React.FC<{ children: React.ReactNode; onClick: (event) => void }> = (props) => {
  return <AuthTextButtonInner className="create-account-without-photo" {...props}>{props.children}</AuthTextButtonInner>;
};

export default AuthTextButton;
